import { EQ_TYP } from '../constant';
import QuantityMakeModal from './QuantityMakeModal';

const SolarArray = (props) => {
  const { eqId, pId, onUpdateModals, setUpdateId, makeList, modalList, onDataUpdate, formData, item,pageType } = props

  return (
      <QuantityMakeModal onDataUpdate={onDataUpdate} formData={formData} item={item} pageType={pageType} eqId={eqId} pId={pId} makeList={makeList} modalList={modalList} name={EQ_TYP.solar} onUpdateModals={onUpdateModals} setUpdateId={setUpdateId} hideIcons isSolarArray />
  );
};

export default SolarArray;
